
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// EXPORT this config so we can use it in authUtils for the secondary app
export const firebaseConfig = {
apiKey: "AIzaSyAt9p3BGKBeNSF26npq2QELA3GIBMToScU",
  apiKey: "AIzaSyCKdTScZ2UK39yLOHBtU-ZgVI_3NGaLNss",
  authDomain: "fastpay-5172e.firebaseapp.com",
  projectId: "fastpay-5172e",
  storageBucket: "fastpay-5172e.firebasestorage.app",
  messagingSenderId: "1085967901876",
  appId: "1:1085967901876:web:9e1bcc636a9235dc81a3e1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
